export const RMA_DEFAULT_HTTP_OPTIONS = { headers: { 'rma.json': 'true' } };
